import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketDrivenShippingMigrateConfirmModalContent } from './MarketDrivenShippingMigrateConfirmModalContent';

interface MarketDrivenShippingMigrateConfirmModalProps {
    id: string;
    modalRef: React.RefObject<HTMLElementTagNameMap['s-modal'] | null>;
    onConfirm: () => void;
}

// The "are you sure?" step before the real migration, shown from MarketDrivenShippingMigratedBanner's
// "Finish migration" button. Always mounted (see the banner's comment on why) — its content is only
// rendered once actually opened.
export const MarketDrivenShippingMigrateConfirmModal: React.FC<MarketDrivenShippingMigrateConfirmModalProps> = ({
    id,
    modalRef,
    onConfirm,
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <s-modal
            ref={modalRef}
            id={id}
            heading={t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.CONFIRM_MODAL.TITLE')}
            onShow={() => setIsOpen(true)}
            onHide={() => setIsOpen(false)}
        >
            {isOpen && <MarketDrivenShippingMigrateConfirmModalContent />}
            <s-button slot="primary-action" variant="primary" onClick={onConfirm}>
                {t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.CONFIRM_MODAL.CONFIRM_BUTTON')}
            </s-button>
            <s-button slot="secondary-actions" commandFor={id} command="--hide">
                {t('BUTTON.CANCEL')}
            </s-button>
        </s-modal>
    );
};

export default MarketDrivenShippingMigrateConfirmModal;
